import React from "react";
import { useTranslation } from "react-i18next";
import Header from "./Header";
import Footer from "./Footer";
import "./TermsOfServicePage.css";

const TermsOfServicePage: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="terms-of-service-page">
      <Header />
      <div className="terms-content">
        <div className="container">
          <div className="page-header">
            <h1 className="page-title">{t("terms.title")}</h1>
            <p className="page-description">
              {t("terms.description")}
            </p>
          </div>

          <div className="terms-sections">
            <div className="terms-main-section">
              <div className="section-card">
                <div className="terms-content">
                  <p className="last-updated">{t("terms.lastUpdated")}</p>

                  <div className="terms-section">
                    <h2 className="section-title">{t("terms.acceptanceOfTerms.title")}</h2>
                    <p>
                      {t("terms.acceptanceOfTerms.content")}
                    </p>
                  </div>

                  <div className="terms-section">
                    <h2 className="section-title">{t("terms.useLicense.title")}</h2>
                    <p>
                      {t("terms.useLicense.description")}
                    </p>
                    <ul>
                      <li>{t("terms.useLicense.modifyCopy")}</li>
                      <li>{t("terms.useLicense.commercialUse")}</li>
                      <li>{t("terms.useLicense.reverseEngineer")}</li>
                      <li>{t("terms.useLicense.removeCopyright")}</li>
                      <li>{t("terms.useLicense.transferMaterials")}</li>
                    </ul>
                  </div>

                  <div className="terms-section">
                    <h2 className="section-title">
                      {t("terms.accountResponsibilities.title")}
                    </h2>
                    <p>
                      {t("terms.accountResponsibilities.content")}
                    </p>
                  </div>

                  <div className="terms-section">
                    <h2 className="section-title">
                      {t("terms.contentOwnership.title")}
                    </h2>
                    <p>
                      {t("terms.contentOwnership.content")}
                    </p>
                  </div>

                  <div className="terms-section">
                    <h2 className="section-title">{t("terms.serviceModifications.title")}</h2>
                    <p>
                      {t("terms.serviceModifications.content")}
                    </p>
                  </div>

                  <div className="terms-section">
                    <h2 className="section-title">
                      {t("terms.limitationOfLiability.title")}
                    </h2>
                    <p>
                      {t("terms.limitationOfLiability.content")}
                    </p>
                  </div>

                  <div className="terms-section">
                    <h2 className="section-title">{t("terms.governingLaw.title")}</h2>
                    <p>
                      {t("terms.governingLaw.content")}
                    </p>
                  </div>

                  <div className="terms-section">
                    <h2 className="section-title">{t("terms.changesToTerms.title")}</h2>
                    <p>
                      {t("terms.changesToTerms.content")}
                    </p>
                  </div>

                  <div className="terms-section">
                    <h2 className="section-title">{t("terms.contactInformation.title")}</h2>
                    <p>
                      {t("terms.contactInformation.content")}
                    </p>
                    <div className="contact-details">
                      <div className="contact-item">
                        <div className="contact-icon">📧</div>
                        <div className="contact-text">
                          <strong>{t("terms.contactInformation.email")}:</strong>
                          <a href="mailto:support@gesslar-platform.com">
                            support@gesslar-platform.com
                          </a>
                        </div>
                      </div>
                      <div className="contact-item">
                        <div className="contact-icon">📞</div>
                        <div className="contact-text">
                          <strong>{t("terms.contactInformation.phone")}:</strong>
                          <a href="tel:+15551234567">(555) 123-4567</a>
                        </div>
                      </div>
                      <div className="contact-item">
                        <div className="contact-icon">🕒</div>
                        <div className="contact-text">
                          <strong>{t("terms.contactInformation.hours")}:</strong>
                          {t("terms.contactInformation.hoursValue")}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="terms-side-section">
              <div className="section-card">
                <h2 className="section-title">{t("terms.quickLinks.title")}</h2>
                <div className="quick-links">
                  <a href="/contact" className="quick-link">
                    <div className="quick-link-icon">📞</div>
                    <div className="quick-link-text">
                      <strong>{t("terms.quickLinks.contactUs")}</strong>
                      <span>{t("terms.quickLinks.contactDescription")}</span>
                    </div>
                  </a>
                  <a href="/privacy" className="quick-link">
                    <div className="quick-link-icon">🔒</div>
                    <div className="quick-link-text">
                      <strong>{t("terms.quickLinks.privacyPolicy")}</strong>
                      <span>{t("terms.quickLinks.readPrivacyPolicy")}</span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsOfServicePage;
